module.exports = __webpack_public_path__ + "img/tshirt_multiple.fb7e88b8.png";